export function toggleGift(val) {
    return (dispatch) => {
        dispatch({ type: 'SET_IS_GIFT', payload: val })
        dispatch(setGiftRecipientToActiveAddress())
    }
}

export function setGiftFirstName(name) {
    return (dispatch) => dispatch({ type: 'SET_GIFT_FIRSTNAME', payload: name })
}

export function setGiftLastName(name) {
    return (dispatch) => dispatch({ type: 'SET_GIFT_LASTNAME', payload: name })
}

export function setGiftMobile(number) {
    return (dispatch) => dispatch({ type: 'SET_GIFT_MOBILE', payload: number })
}

export function setGiftRecipientToActiveAddress() {
    return (dispatch, getState) => {
        const activeAddress = getState().address.active

        if (
            activeAddress.firstName != null ||
            activeAddress.lastName != null ||
            activeAddress.mobile != null
        ) {
            dispatch(setGiftFirstName(activeAddress.firstName))
            dispatch(setGiftLastName(activeAddress.lastName))
            dispatch(setGiftMobile(activeAddress.mobile))
        }
    }
}
